<template>
    <div class="filter-status">
        <div class="buttons">
            <button type="button"
                :class="buttonClass(filterStatuses.currentGames)"
                @click="handleSwitchClick(filterStatuses.currentGames)"
            >
                {{ $t('predictors.currentGames') }}
            </button>
            <button type="button"
                :class="buttonClass(filterStatuses.previousGames)"
                @click="handleSwitchClick(filterStatuses.previousGames)"
            >
                {{ $t('predictors.previousGames') }}
            </button>
        </div>
    </div>
</template>

<script>
// 3rd party
import {
    mapGetters,
} from 'vuex';

const FILTER_STATUSES = {
    currentGames: 'currentGames',
    previousGames: 'previousGames',
};

export default {
    name: 'status-switch-v2',
    computed: {
        ...mapGetters('predictorSportEvents', ['getSportEventsFilterStatus']),

        filterStatuses: () => FILTER_STATUSES,
    },
    methods: {
        handleSwitchClick(status) {
            this.$emit('onChangeStatus', status);
        },
        buttonClass(filterStatus) {
            return [
                'status-button',
                {
                    'status-button--active': this.getSportEventsFilterStatus === filterStatus,
                },
            ];
        },
    },
};
</script>

<style lang="scss" scoped>
.filter-status {
    display: flex;
    flex-direction: column;

    & > .buttons {
        .status-button {
            min-width: 13.5rem;
            height: 3rem;
            background-color: $alabaster-color;
            border-radius: 20px;
            font-family: Nunito;
            font-size: 1.5rem;
            color: $daintree-color;
            border: 1px solid $alto-color;
            cursor: pointer;

            &:first-of-type {
                margin-right: 1rem;
            }

            &--active {
                background-color: $lima-color-opaque;
                border: 1px solid $lima-color;
                font-weight: bold;
            }
        }
    }
}
</style>